import { useState } from 'react'
import { useAdminAuth } from '../../shared/auth/admin-auth-context'
import { PERIODS } from '../overview/queries'
import type { PeriodDays } from '../overview/queries'
import { BucketSection } from './bucket-section'
import { CardsTable } from './cards-table'
import { useCardRatings } from './queries'
import styles from '../overview/overview.module.css'

export function CardRatingsPage() {
  const { user, status } = useAdminAuth()
  const staff = status === 'authenticated' && (user?.role === 'admin' || user?.role === 'expert')
  const [period, setPeriod] = useState<PeriodDays>(30)
  const ratings = useCardRatings(period, staff)

  if (!staff) return <p className="error-box">Раздел доступен только сотрудникам.</p>

  return (
    <div>
      <header className={styles.head}>
        <div>
          <h1>Отклик</h1>
          <p className="muted">Как люди реагируют на карту дня и свою карту из трёх. Время московское.</p>
        </div>
        <div className={styles.periods} role="radiogroup" aria-label="Период">
          {PERIODS.map((p) => (
            <button
              key={p}
              role="radio"
              aria-checked={period === p}
              className={period === p ? styles.periodActive : styles.period}
              onClick={() => setPeriod(p)}
            >
              {p} дней
            </button>
          ))}
        </div>
      </header>

      {ratings.isError && <p className="error-box">Не удалось загрузить реакции, обновите страницу.</p>}
      {ratings.isPending && <div className="spinner" aria-label="Загрузка" />}

      {ratings.data && (
        <>
          <BucketSection id="cr-daily" title="Карта дня" bucket={ratings.data.daily} />
          <BucketSection id="cr-pick" title="Выбор 1 из 3" bucket={ratings.data.pick} />
          <CardsTable cards={ratings.data.cards} />
        </>
      )}
    </div>
  )
}
